import { FormControl, FormHelperText, Stack, TextField } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import { useContext } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GlobalDataContext } from "../../../../../../contexts/GlobalData";
import { MANGAE_WORKING_HOURS } from "../../../../../../enums/PermissionTitles";
import useUser from "../../../../../../hooks/useUser";

export default function NonWorkingDatesForm({ submitData, nonWorkingDate }) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useFormContext();
  const { isPermissionAllowed } = useContext(GlobalDataContext);
  const { roles } = useUser();
  const isDisabled = !isPermissionAllowed(MANGAE_WORKING_HOURS) && !roles.master;
  
  return (
    <Stack>
      <Controller
        name={`date`}
        control={control}
        defaultValue={null}
        rules={{ required: t("CantBeEmpty") }}
        render={({ field }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <FormControl error={!!errors.date}>
              <MobileDatePicker
                disabled={isDisabled}
                label={
                  isDisabled
                    ? t("NoPermissionToManageWorkingHours")
                    : t("AddNonWorkingDate")
                }
                value={field.value ?? null}
                onChange={(newValue) => field.onChange(newValue)}
                renderInput={(params) => <TextField {...params} />}
                onAccept={(val) => {
                  field.onChange(val);
                  handleSubmit(submitData());
                }}
                shouldDisableDate={(date) => disableDate(date, nonWorkingDate)}
              />
              <FormHelperText>
                {errors.date ? errors.date.message : ""}
              </FormHelperText>
            </FormControl>
          </LocalizationProvider>
        )}
      />
    </Stack>
  );
}

function disableDate(existingDate, datesList = []) {
  const formatedDate = dayjs(existingDate).format("DD/MM/YYYY")
  return datesList.includes(formatedDate)
}
